// Preserve the script's declared output order for signal configuration, even
// when its visual plots are split between lines and histogram overlays.
export function customSignalData(result,candles,plotConfig={}) {
    const data=result?.__data ?? result;
    const outputs=Array.isArray(data)||ArrayBuffer.isView(data)?[{key:'value',data}]:Object.entries(data||{}).filter(([,values])=>Array.isArray(values)||ArrayBuffer.isView(values)).map(([key,data])=>({key,data}));
    return {outputs:outputs.map((output,i)=>({key:output.key,label:plotConfig.outputs?.[i]?.label||output.key})),
        data:candles.map((candle,i)=>[candle[0],...outputs.map(output=>{
            const raw=output.data[i],value=raw&&typeof raw==='object'?raw.value:raw;
            return typeof value==='number'&&Number.isFinite(value)?value:null;
        })])};
}
